module.exports = __webpack_public_path__ + "img/04.c5bcaa29.jpg";